import messagesReducer from './messages-reducer'
import navigationReducer from './navigation-reducer'
import authReducer from './auth-reducer'

export default {
  messages: messagesReducer,
  navigation: navigationReducer,
  auth: authReducer
}



// WEBPACK FOOTER //
// ./src/app/reducers/index.js